import { Controller } from 'stimulus';
import axios from 'axios';
import {
  turbolinksChangeUrl
} from '../../utils/urls';

export default class extends Controller {
  static targets = [
    'filter',
    'select',
    'content'
  ]

  state = {
    loading: false,
    fontLoadTimeout: 250,
    component: 'experiences-carousel',
    activeClass: 'is-active',
    parser: new DOMParser(),
    activeFilter: false
  }

  connect() {
    const {
      state
    } = this;
  }

  filterChange(event) {
    const {
      state
    } = this;
    event.preventDefault();
    event.stopPropagation();
    const filter = event.currentTarget.value;
    if (!state.loading && filter !== state.activeFilter) {
      state.activeFilter = filter;
      this.replaceContent();
      this.setActiveFilter();
    }
  }

  filterTurbovisit(event) {
    const {
      state
    } = this;
    event.preventDefault();
    event.stopPropagation();
    const url = event.currentTarget.value;
    if (Turbolinks) {
      Turbolinks.visit(url);
    } else {
      window.location.href = url;
    }
  }

  filterClick(event) {
    const {
      state
    } = this;
    event.preventDefault();
    event.stopPropagation();
    const filter = event.currentTarget.getAttribute('href');
    if (!state.loading && filter !== state.activeFilter) {
      state.activeFilter = filter;
      this.replaceContent();
      this.setActiveFilter();
      this.setActiveSelect();
    }
  }

  replaceContent(url) {
    const {
      state
    } = this;
    if (!state.loading) {
      state.loading = true;
      turbolinksChangeUrl(state.activeFilter);
      axios
        .get(state.activeFilter)
        .then((response) => {
          this.parseAndAppendResponse(response);
        })
        .catch((error) => {
          console.error('Experiences carousel : replaceContent : error', error);
          window.location.reload();
        });
    }
  }

  parseAndAppendResponse(response) {
    const {
      state
    } = this;
    const html = state.parser.parseFromString(response.data, 'text/html');
    const content = html.querySelector('[data-target="experiences-carousel.content"]').innerHTML;
    this.contentTarget.innerHTML = content;
    state.loading = false;
  }

  setActiveFilter() {
    const {
      state
    } = this;
    this.filterTargets
      .forEach((node) => node.classList.remove(state.activeClass));
    this.filterTargets.filter((node) => node.getAttribute('href') === state.activeFilter)
      .forEach((node) => node.classList.add(state.activeClass));
  }

  setActiveSelect() {
    const {
      state
    } = this;
    this.selectTarget.value = state.activeFilter;
  }
}
